module.exports = __webpack_public_path__ + "static/media/sama.71822228.png";